jQuery(function($) {
    const base = "gc-quantity";
    $(`.${base}__minus`).on("click", function() {
		const input = $(this).next();

		if (input.is(':disabled')) {
			return;
		}

		if (input.val() > 1) {
			const value = Number(input.val()) - 1;
			input.val(value).trigger('change');
		}
    });

	$(`.${base}__plus`).on("click", function() {
		const input = $(this).prev();

		if (input.is(':disabled')) {
			return;
		}

		const value = Number(input.val()) + 1;
		input.val(value).trigger('change');
    });

	$(`.${base}__input`).on("change keyup", function (e) {
		e.preventDefault();
		const value = Number($(this).val());
		if (value > 1) {
			$(this).val(value);
		} else {
			$(this).val(1);
		}
	});
});